import React from 'react';
import { LOGO_URL } from '../data/brand';
export function Footer() {
  return <footer className="w-full bg-ink-900 py-14 sm:py-16" data-id="element-72" data-mp="3gezc50oadkzk">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-73" data-mp="3ggk72reij5xy">
        <img src={LOGO_URL} alt="EXPANDE — Tu visión. Tus posibilidades." className="h-10 w-auto opacity-60 sm:h-12" data-id="element-74" data-mp="32onll67cnuaj" />
        <p className="mt-8 max-w-3xl font-sans text-[13px] font-light leading-relaxed text-steel-400" data-id="element-75" data-mp="36n3axgqwler4">
          Esta es una oportunidad de negocio independiente, no un empleo
          tradicional con salario fijo. La compensación está basada en desempeño
          y resultados. Algunas actividades requieren capacitación y las
          licencias correspondientes. Los ingresos no están garantizados.
        </p>
      </div>
    </footer>;
}